import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import SharedGPAPlanner from "./SharedGPAPlanner";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import StudyCalculatorImg from "../../../images/StudyCalculatorImg.webp";
const TITLE = "تخطيط المعدل التراكمي لمقرراتك الجامعية بفعالية";
const DESCRIPTION =
  "اعرف كيفية تخطيط المعدل التراكمي لمقرراتك الجامعية بفعالية. تعرف على أفضل الاستراتيجيات لتحسين وتخطيط المعدل التراكمي لتحقيق النجاح الأكاديمي.";
const KEYWORDS =
  "تخطيط المعدل التراكمي, استراتيجيات تخطيط المعدل, تحسين المعدل التراكمي, نجاح أكاديمي";
const OG_URL = "https://do-calculate.com/calculator/ar/gpaplanner";
function GPAPlanner() {
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        IMAGE={StudyCalculatorImg}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>{DESCRIPTION}</p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <SharedGPAPlanner />
            </div>
            <div>
              <br />
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE} </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>{" "}
                  </u>
                  <p>
                    كل طالب لديه نمط تعلمه الخاص. بعض الأشخاص يفضلون العمل
                    لساعات طويلة متواصلة لإكمال مهمة معينة، في حين يمكن للآخرين
                    أخذ عدة استراحات. ليس هناك استراتيجية مثالية، وكيفية اقتراب
                    الشخص من عملية التعلم تعتمد بشكل كبير على نمط التعلم الخاص
                    به، بالإضافة إلى التزامه باستراتيجية دراسية تتناسب مع جدوله
                    الزمني ورغباته. الطريقة التي تزيد قيمة الوقت المستغل هي على
                    الأرجح الأكثر فعالية في تحسين عملية التعلم وبالتالي تحسين
                    المعدل التراكمي للدرجات.
                  </p>
                  <p>
                    أيضا، تنظيم الأعمال التي يجب القيام بها، وكذلك الملاحظات
                    التي تم التقاطها مهمة أيضاً. من المهم أن يكون بإمكانك العثور
                    على المعلومات ذات الصلة بنفس القدر الذي يتم فيه أخذ
                    الملاحظات في الصف. تصبح الملاحظات قيمة بشكل كبير عندما يمكن
                    استخدامها لدعم عملية التعلم. يقدم الأساتذة كميات كبيرة من
                    المعلومات أثناء محاضرة الدورة، ليس من الضروري أن يتمكن
                    الطالب من معالجة كلها في وقت قصير. لذا من المهم ممارسة أخذ
                    الملاحظات بطريقة تتيح للطالب الرجوع إليها لاحقًا والبحث عن
                    المعلومات.
                  </p>
                  <p>
                    إدارة الوقت أيضا جزء هام من التخطيط. هناك فقط 24 ساعة في
                    اليوم، وليس بإمكان الشخص استخدامها بشكل فعّال جميعها. بينما
                    التعلم مهم، إلا أن أخذ مزيد من الدورات أو المشاركة في
                    الأنشطة أكثر مما يمكن للشخص التعامل معه يمكن أن يكون ضارًا
                    على حد سواء بعملية التعلم وبالمعدل التراكمي للدرجات. بمجرد
                    تحديد جميع الدورات، يمكن أن يساعد تخصيص الوقت لكل دورة في
                    وضع كمية العمل والوقت اللازم بالمنظور الصحيح. بينما قد يبدو
                    كمية العمل اللازمة لعدد من الدورات مهمة في البداية، فإن
                    التخطيط لكيفية ومتى الاقتراب من العمل لكل دورة قد يساعد في
                    تقليل التوتر وزيادة الكفاءة بمجرد كمية العمل المحددة (أو قد
                    يساعد الشخص على إدراك أنه يعامل مشكلة أكبر مما يستطيع
                    التعامل معها).
                  </p>
                  <p>
                    استعراض العمل بانتظام، من حيث الدراسة، هو جانب آخر من إدارة
                    الوقت. يتم تغطية كمية كبيرة من المعلومات في دورة الدراسة
                    بحلول موعد الامتحان النهائي، واستعراض بعض المعلومات بانتظام
                    على مر الزمن غالبًا ما يكون أكثر فعالية من محاولة حفظ كل
                    المعلومات قبل الامتحان. تعلم المعلومات من خلال الاستعراض
                    الدوري يمكن أن يوفر في النهاية وقتًا أكثر للشخص وربما يؤهله
                    لأداء أفضل في الامتحان، وبالتالي تحسين المعدل التراكمي
                    للدرجات.
                  </p>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default GPAPlanner;
